import wrapInObserver from '../../wrapInObserver';
import SafetyBanner from './SafetyBanner';
import SafetyBannerMobile from './SafetyBannerMobile';
import logger from '../../../logger';
import generatedHooks from '../../../hooks/generatedHooks';

import { makeSafetyLandingUrl } from '../../../utils/urlProvider';
import BannerStore from '../../../stores/bannerStore';

const { useBannerStore } = generatedHooks;

const mapProps = () => {
  try {
    const bannerStore = useBannerStore(store => store);

    return {
      safetyLandingUrl: makeSafetyLandingUrl(),
      closeBanner: bannerStore.putSafetyBannerViewedFlag,
      imageUrl: bannerStore.banners[BannerStore.BANNER_TYPES.SAFETY].imageUrl,
    };
  } catch (error) {
    logger.error(error, { sentryMessage: 'Error while rendering SafetyBanner' });
    return {};
  }
};

export default wrapInObserver(SafetyBanner, mapProps, SafetyBannerMobile);
